<app-logged-in-header
    [backgroundColor]="'#00637C'"
    [dark]="true"
    [showBrand]="true"
    brandLogoSrc="assets/svgs/logo-white.svg"
></app-logged-in-header>

<div class="max-w-3xl mx-auto my-5">
    <button
        (click)="goBack()" 
        class="px-3 py-2 mb-3 rounded-md bg-[#9AA0B3] text-sm text-white flex items-center gap-2 hover:bg-[#8d93a4] duration-300"
    >
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" stroke-color="currentColor">
            <path d="M0 0h24v24H0z" fill="none" />
            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                <path stroke-dasharray="20" d="M21 12h-17.5">
                    <animate fill="freeze" attributeName="stroke-dashoffset" dur="0.3s" values="20;0" />
                </path>
                <path stroke-dasharray="12" stroke-dashoffset="12" d="M3 12l7 7M3 12l7 -7">
                    <animate fill="freeze" attributeName="stroke-dashoffset" begin="0.3s" dur="0.2s" to="0" />
                </path>
            </g>
        </svg>

        <p>Back</p>
    </button>

    <!-- Card -->
    <div class="border border-[#E6E6E6] rounded-xl overflow-hidden">
        <!-- Head -->
        <div class="pt-[29px] px-9 pb-9 bg-[#1697B4] text-white">
            <h4 class="mb-1 text-2xl font-bold">Complete Payment</h4>
            <p>Secure payment processing</p>
        </div>

        <div class="py-4 px-6">
            <div class="mb-8">
                <div class="px-2 py-3 flex items-center justify-between border-b border-[#E6E6E6]">
                    <p class="text-sm font-light">Vendor</p>
                    <p class="text-sm text-[#595A69] font-bold">{{ payment?.vendorName || "-" }}</p>
                </div>
                <div class="px-2 py-3 flex items-center justify-between border-b border-[#E6E6E6]">
                    <p class="text-sm font-light">Category</p>
                    <p class="text-sm text-[#595A69] font-bold">{{ payment?.categoryName || "-" }}</p>
                </div>
                <div class="px-2 py-3 flex items-center justify-between border-b border-[#E6E6E6]">
                    <p class="text-sm font-light">Amount to Pay</p>
                    <p class="text-sm text-[#595A69] font-bold">{{ (payment?.amountToPay | currency:"NGN") || "-" }}</p>
                </div>
            </div>

            <!-- <div>
                <p class="mb-2 text-[#595A69] font-medium">Select Payment Channel</p>
                <div class="grid grid-cols-2 items-center gap-3">
                    <img 
                        src="/assets/images/interswitch.png" 
                        alt="Interswitch logo"
                        class="h-full border border-[#E2E2E2] rounded-lg"
                    >
                    <img 
                        src="/assets/images/remita.jpg" 
                        alt="Remitta logo"
                        class="border border-[#E2E2E2] rounded-lg"
                    >
                </div>
            </div> -->

            <div class="mb-3 mt-8 flex items-center justify-center gap-1">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.66667 7.33594V4.66927C4.66667 3.78522 5.01786 2.93737 5.64298 2.31225C6.2681 1.68713 7.11595 1.33594 8 1.33594C8.88406 1.33594 9.7319 1.68713 10.357 2.31225C10.9821 2.93737 11.3333 3.78522 11.3333 4.66927V7.33594M3.33333 7.33594H12.6667C13.403 7.33594 14 7.93289 14 8.66927V13.3359C14 14.0723 13.403 14.6693 12.6667 14.6693H3.33333C2.59695 14.6693 2 14.0723 2 13.3359V8.66927C2 7.93289 2.59695 7.33594 3.33333 7.33594Z" stroke="#9AA0B3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
    
                <p class="text-sm text-[#9AA0B3] font-light">Secured by 256-bit SSL encryption</p>
            </div>
    
            <button 
                (click)="proceedToPayment()"
                [disabled]="isInitiatingPayment"
                class="w-full p-3 bg-[#1697B4] text-white flex items-center justify-center gap-2 rounded hover:bg-[#148aa5] disabled:cursor-not-allowed disabled:opacity-50"
            >
                @if (isInitiatingPayment) {
                    <div class="flex items-center gap-2">
                        <span
                            class="inline-block size-6 animate-spin rounded-full border-4 border-slate-400/40 border-t-white"
                            aria-hidden="true">
                        </span>
                        <p>Initiating Payment...</p>
                    </div>
                } @else {
                    <p>Pay {{ (payment?.amountToPay | currency:"NGN") || "-" }}</p>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.91406 6.9974H11.0807M6.9974 11.0807L11.0807 6.9974L6.9974 2.91406" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                }
            </button>
        </div>

    </div>
</div>

@if (initiatePaymentProcess) {
    <app-payment-modal [applicationId]="payment.applicationId" (close)="onClose()"></app-payment-modal>
}